module.exports = __webpack_public_path__ + "img/15-onebg.79414da5.png";